<script>
    import { Route } from "svelte-router-spa";
  
    export let currentRoute;
    export let params = {};
  </script>
  
  <div style="margin:0;padding:0;">
    <Route {currentRoute} {params} />
  </div>